import classes from './ChatWidget.module.scss'
import { ChatBalance } from './types'
import { formatChatMoney } from './chatFormatters'

interface Props {
  balances: ChatBalance[]
}

/**
 * "Cari Bakiyeniz" kartları: döviz başına bir kart (para birimi + AKTİF rozeti + etiket + tutar).
 * Kart başlığını bot metni verir; bileşen yalnızca kart ızgarasını çizer.
 */
export default function BalanceCards({ balances }: Props) {
  if (balances.length === 0) return null

  return (
    <div className={classes.balanceGrid}>
      {balances.map((b, i) => (
        <div key={`${b.currency}-${i}`} className={classes.balanceCard}>
          <div className={classes.balanceCardHead}>
            <span className={classes.balanceCurrency}>{b.currency === 'TRY' ? 'TL' : b.currency}</span>
            {b.isActive && <span className={classes.balanceActiveBadge}>Aktif</span>}
          </div>
          <div className={classes.balanceLabel}>{b.label?.trim() || 'Bakiye'}</div>
          <div className={classes.balanceAmount}>{formatChatMoney(b.amount, b.currency)}</div>
        </div>
      ))}
    </div>
  )
}
